import Grid from "@mui/material/Grid";
import * as React from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Paper from "@mui/material/Paper";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";

import SaveIcon from "@mui/icons-material/Save";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { MaskedInput, Message, SelectPicker, Uploader } from "rsuite";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { createSvgIcon } from "@mui/material/utils";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Slide from "@mui/material/Slide";
import Draggable from "react-draggable";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { useToaster, Notification } from "rsuite";
import { useMaterialUIController } from "context";
import { CREATE_CUSTOMER } from "Permissions";
import { AC_PAYOUT } from "Permissions";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const PlusIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
  </svg>,
  "Plus"
);

function NewEntry() {
  const [controller, dispatch] = useMaterialUIController();
  const [fileList, setfileList] = React.useState([]);
  const { auth, persist } = controller;
  const [usersList, setUsersList] = React.useState([]);
  const [DSOlist, setDSOlist] = React.useState([]);
  const [villageList, setVillageList] = React.useState([]);
  const [casteList, setCasteList] = React.useState([]);
  const [brokerList, setBrokerList] = React.useState([]);
  const [customersList, setCustomersList] = React.useState([]);
  const [insuranceCoList, setInsuranceCoList] = React.useState([]);
  const [policytypeList, setPolicyTypeList] = React.useState([]);
  const [vehicletypeList, setVehicleTypeList] = React.useState([]);
  const [paidviaList, setPaidViaList] = React.useState([]);
  const [policyCategoryList, setPolicyCategoryList] = React.useState([]);
  const toaster = useToaster();
  const [addCustomerData, setAddCustomerData] = React.useState({});
  const [policyData, setPolicyData] = React.useState({});

  const [selectedDate, setSelectedDate] = React.useState(null);
  const [startDate, setStartDate] = React.useState(null);
  const [policyDate, setPolicyDate] = React.useState(null);
  const [paymentDate, setPaymentDate] = React.useState(null);
  const [customername, setcustomername] = React.useState("");
  const [type, setType] = React.useState("");
  const axiosPrivate = useAxiosPrivate();

  const [openAddCustomer, setOpenAddCustomer] = React.useState(false);

  const [addBrokerData, setAddBrokerData] = React.useState({});
  const [openAddBroker, setOpenAddBroker] = React.useState(false);
  const [openAddPaidVia, setOpenAddPaidVia] = React.useState(false);
  const [policyID, setpolicyID] = React.useState(null);

  const handleOpenAddBroker = () => {
    setOpenAddBroker(true);
  };

  const handleCloseAddBroker = () => {
    setOpenAddBroker(false);
  };

  const handleAddBrokerChange = (evt) => {
    const value = evt.target.value;
    setAddBrokerData((prev) => ({ ...prev, [evt.target.name]: value }));
  };

  const AddBroker = async () => {
    if (
      addBrokerData.fullname === "" ||
      addBrokerData.firmname === "" ||
      addBrokerData.email === "" ||
      addBrokerData.officialemail === "" ||
      addBrokerData.mobile === "" ||
      addBrokerData.officeno === "" ||
      addBrokerData.address === ""
    ) {
      toaster.push(
        <Notification type="error" header="Error">
          {`All Fields are required.`}
        </Notification>,
        { placement: "topEnd" },
        { duration: 1000 }
      );
      return;
    }
    try {
      const datatosend = {
        fullname: addBrokerData.fullname,
        firmname: addBrokerData.firmname,
        email: addBrokerData.email,
        officialemail: addBrokerData.officialemail,
        mobile: addBrokerData.mobile,
        officeno: addBrokerData.officeno,
        address: addBrokerData.address,
        usertype: "Broker",
      };
      const response = await axiosPrivate.post("/AddAgentDetails.php", datatosend);
      const result = response.data;
      if (result.status === 1) {
        getUsersBroker();
        toaster.push(
          <Notification type="success" header="Success">
            {`Broker added successfully`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
        handleCloseAddBroker();
        setAddBrokerData({});
      }

      if (result.status === 0) {
        toaster.push(
          <Notification type="error" header="Error">
            {result.Error}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };
  const getCasteList = () => {
    axiosPrivate
      .post("/LoadCasteList.php")
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: item.Name,
              value: item.Name,
            }));
            // console.log(data);
            setCasteList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setCasteList([]);
        }
      })
      .catch((e) => {
        setCasteList([]);
      });
  };
  const getPolicyCategoryList = () => {
    axiosPrivate
      .post("/LoadPolicyCategoryList.php")
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              id: item.SrNo,
              label: item.Name,
              value: item.Name,
            }));
            // console.log(data);
            setPolicyCategoryList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setPolicyCategoryList([]);
        }
      })
      .catch((e) => {
        setPolicyCategoryList([]);
      });
  };
  const [addDSOData, setAddDSOData] = React.useState({});
  const [openAddDSO, setOpenAddDSO] = React.useState(false);

  const handleOpenAddDSO = () => {
    setOpenAddDSO(true);
  };

  const handleCloseAddDSO = () => {
    setOpenAddDSO(false);
  };

  const handleAddDSOChange = (evt) => {
    const value = evt.target.value;
    setAddDSOData((prev) => ({ ...prev, [evt.target.name]: value }));
  };

  const addDSO = async () => {
    if (
      addDSOData.fullname === "" ||
      addDSOData.email === "" ||
      addDSOData.mobile === "" ||
      addDSOData.officeno === "" ||
      addDSOData.officialemail === "" ||
      addDSOData.firmname === "" ||
      addDSOData.address === "" ||
      addDSOData.remark === ""
    ) {
      toaster.push(
        <Notification type="error" header="Error">
          {`All Fields are required.`}
        </Notification>,
        { placement: "topEnd" },
        { duration: 1000 }
      );
      return;
    }
    try {
      const datatosend = {
        fullname: addDSOData.fullname,
        firmname: addDSOData.firmname,

        email: addDSOData.email,
        officialemail: addDSOData.officialemail,
        mobile: addDSOData.mobile,
        officeno: addDSOData.officeno,
        address: addDSOData.address,
        usertype: "DahiyaMitra",
      };
      const response = await axiosPrivate.post("/AddAgentDetails.php", datatosend);
      const result = response.data;
      if (result.status === 1) {
        getUsersByType();
        toaster.push(
          <Notification type="success" header="Success">
            {`Dahiya Mitra added successfully`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
        handleCloseAddDSO();
        setAddDSOData({});
      }

      if (result.status === 0) {
        toaster.push(
          <Notification type="error" header="Error">
            {result.Error}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };

  const handleOpenAddCustomer = () => {
    setOpenAddCustomer(true);
  };

  const handleCloseAddCustomer = () => {
    setOpenAddCustomer(false);
  };
  const [openAddInsuranceCo, setOpenAddInsuranceCo] = React.useState(false);

  const handleOpenAddInsuranceCo = () => {
    setOpenAddInsuranceCo(true);
  };

  const handleCloseAddInsuranceCo = () => {
    setOpenAddInsuranceCo(false);
  };

  const [openAddPolicyType, setOpenAddPolicyType] = React.useState(false);

  const handleOpenAddPolicyType = () => {
    setOpenAddPolicyType(true);
  };

  const handleCloseAddPolicyType = () => {
    setOpenAddPolicyType(false);
  };

  const [openAddVehicleType, setOpenAddVehicleType] = React.useState(false);

  const handleOpenAddVehicleType = () => {
    setOpenAddVehicleType(true);
  };

  const handleCloseAddVehicleType = () => {
    setOpenAddVehicleType(false);
  };
  const handleOpenAddPaidVia = () => {
    setOpenAddPaidVia(true);
  };

  const handleCloseAddPaidVia = () => {
    setOpenAddPaidVia(false);
  };

  function handleAddCustomerChange(evt) {
    const value = evt.target.value;
    setAddCustomerData((prev) => ({ ...prev, [evt.target.name]: value }));
  }
  function handleAddpolicydata(evt) {
    const value = evt.target.value;
    setPolicyData((prev) => ({ ...prev, [evt.target.name]: value }));
  }

  /*   const AddUser = async () => {
    if (
      addUserData.firstname === "" ||
      addUserData.lastname === "" ||
      addUserData.username === "" ||
      addUserData.email === "" ||
      addUserData.mobile === "" ||
      usertype === ""
    ) {
      toaster.push(
        <Notification type="error" header="Error">
          {`All Fields are required.`}
        </Notification>,
        { placement: "topEnd" },
        { duration: 1000 }
      );
      return;
    }
    try {
      const datatosend = {
        firstname: addUserData.firstname,
        lastname: addUserData.lastname,
        username: addUserData.username,
        email: addUserData.email,
        mobile: addUserData.mobile,
        usertype: usertype,
      };
      const response = await axiosPrivate.post("/AddUser.php", datatosend);
      const result = response.data;
      if (result.status === 1) {
        toaster.push(
          <Notification type="success" header="Success">
            {`User created successfully`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
        handleClose();
        setAddUserData({});
      }

      if (result.status === 0) {
        toaster.push(
          <Notification type="error" header="Error">
            {result.Error}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };

  const handleAddUserChange = (event) => {
    setUsertype(event.target.value);
  }; */

  const AddCustomer = async () => {
    const { fullname, address, mobile2, refby, village, caste } = addCustomerData;
    if (fullname === "" || village === "" || mobile2 === "" || refby === "") {
      toaster.push(
        <Notification type="error" header="Error">
          {`All Fields are required.`}
        </Notification>,
        { placement: "topEnd" },
        { duration: 1000 }
      );
      return;
    }
    try {
      const datatosend = {
        fullname,
        address,
        mobile2,
        refby,
        village,
        caste,
      };
      const response = await axiosPrivate.post("/AddCustomer.php", datatosend);
      const result = response.data;
      console.log(response);
      if (result.status === 1) {
        toaster.push(
          <Notification type="success" header="Success">
            {`Customer added successfully`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
        setOpenAddCustomer(false);
        setAddCustomerData({});
        setType("");
        getCustomers();
      }

      if (result.status === 0) {
        toaster.push(
          <Notification type="error" header="Error">
            {result.Error}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };

  React.useEffect(() => {
    const { commpernet, commperod, commpertp, netpremium, odpremium, tppremium } = policyData;
    let isSubscribed = true;
    if (isSubscribed) {
      if (
        !isNaN(netpremium) &&
        !isNaN(odpremium) &&
        !isNaN(tppremium) &&
        !isNaN(commpernet) &&
        !isNaN(commperod) &&
        !isNaN(commpertp)
      ) {
        setPolicyData((a) => {
          return {
            ...a,
            commnetamount: (netpremium * commpernet) / 100,
            commod: (odpremium * commperod) / 100,
            commtp: (tppremium * commpertp) / 100,
            totalcomm:
              (netpremium * commpernet) / 100 +
              (odpremium * commperod) / 100 +
              (tppremium * commpertp) / 100,
          };
        });
      }
    }
    return () => {
      isSubscribed = false;
    };
  }, [
    policyData.netpremium,
    policyData.odpremium,
    policyData.tppremium,
    policyData.commpernet,
    policyData.commperod,
    policyData.commpertp,
  ]);

  React.useEffect(() => {
    let { grosspremium, paymentmade, discount } = policyData;

    if (paymentmade === undefined || paymentmade === null || isNaN(paymentmade)) {
      paymentmade = 0;
    }
    if (discount === undefined || discount === null || isNaN(discount)) {
      discount = 0;
    }
    let isSubscribed = true;
    if (isSubscribed) {
      if (!isNaN(grosspremium) && !isNaN(paymentmade) && !isNaN(discount)) {
        setPolicyData((a) => {
          return {
            ...a,
            paymentselfbalance: grosspremium - paymentmade - discount,
          };
        });
      }
    }
    return () => {
      isSubscribed = false;
    };
  }, [policyData.grosspremium, policyData.paymentmade, policyData.discount]);

  const AddInsuranceCo = async () => {
    console.log(addCustomerData);
    const { insuranceco } = addCustomerData;
    if (!insuranceco) {
      toaster.push(
        <Notification type="error" header="Error">
          {`This Fields is required.`}
        </Notification>,
        { placement: "topEnd" },
        { duration: 1000 }
      );
      return;
    }
    try {
      const datatosend = {
        insuranceco,
      };
      const response = await axiosPrivate.post("/AddInsuranceCo.php", datatosend);
      const result = response.data;
      console.log(response);
      if (result.status === 1) {
        toaster.push(
          <Notification type="success" header="Success">
            {`Insurance Co added successfully`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
        handleCloseAddInsuranceCo(false);
        setAddCustomerData({});
        getInsuranceCo();
      }

      if (result.status === 0) {
        toaster.push(
          <Notification type="error" header="Error">
            {result.Error}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };

  const AddPolicyType = async () => {
    const { policytype } = addCustomerData;
    if (policytype === "") {
      toaster.push(
        <Notification type="error" header="Error">
          {`This Fields is required.`}
        </Notification>,
        { placement: "topEnd" },
        { duration: 1000 }
      );
      return;
    }
    try {
      const datatosend = {
        policytype,
      };
      const response = await axiosPrivate.post("/AddPolicyType.php", datatosend);
      const result = response.data;
      console.log(response);
      if (result.status === 1) {
        toaster.push(
          <Notification type="success" header="Success">
            {`Policy Type added successfully`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
        handleCloseAddPolicyType(false);
        setAddCustomerData({});
        getPolicyType();
      }

      if (result.status === 0) {
        toaster.push(
          <Notification type="error" header="Error">
            {result.Error}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };

  const AddVehicleType = async () => {
    const { vehicleType } = addCustomerData;
    if (vehicleType === "") {
      toaster.push(
        <Notification type="error" header="Error">
          {`This Fields is required.`}
        </Notification>,
        { placement: "topEnd" },
        { duration: 1000 }
      );
      return;
    }
    try {
      const datatosend = {
        vehicleType,
      };
      const response = await axiosPrivate.post("/AddVehicleType.php", datatosend);
      const result = response.data;
      console.log(response);
      if (result.status === 1) {
        toaster.push(
          <Notification type="success" header="Success">
            {`Vehicle Type added successfully`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
        handleCloseAddVehicleType(false);
        setAddCustomerData({});
        getVehicleType();
      }

      if (result.status === 0) {
        toaster.push(
          <Notification type="error" header="Error">
            {result.Error}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };
  const AddPaidVia = async () => {
    const { paidvia } = addCustomerData;
    if (paidvia === "") {
      toaster.push(<Message type="error">{`This Fields is required.`}</Message>);
      return;
    }
    try {
      const datatosend = {
        paidvia,
      };
      const response = await axiosPrivate.post("/AddPaidVia.php", datatosend);
      const result = response.data;
      console.log(response);
      if (result.status === 1) {
        toaster.push(
          <Notification type="success" header="Success">
            {`Added successfully`}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
        handleCloseAddPaidVia(false);
        getPaidVia();
      }

      if (result.status === 0) {
        toaster.push(
          <Notification type="error" header="Error">
            {result.Error}
          </Notification>,
          { placement: "topEnd" },
          { duration: 1000 }
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };

  React.useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      var newDate = new Date(startDate);
      let abc = moment(newDate).add(364, "days");
      setSelectedDate(abc);
    }
    return () => {};
  }, [startDate]);

  const AddPolicyData = async () => {
    const {
      brokerorself,

      paymentmade,
      discount,
      paymentselfbalance,
      commnetamount,
      commod,
      commtp,
      commpernet,
      commperod,
      commpertp,
      grosspremium,
      insurancecompany,
      netpremium,
      odpremium,
      tppremium,
      policyno,
      policytype,
      totalcomm,
      vehiclemodel,
      vehicleregno,
      DSO,
      DSOName,
      broker,
      brokername,
      modelyear,
      paidvia,
      policycategory,
    } = policyData;
    console.log(policyData);
    console.log(
      modelyear,

      paymentmade,
      discount,
      paymentselfbalance,
      commnetamount,
      commod,
      commtp,
      commpernet,
      commperod,
      commpertp,
      grosspremium,
      insurancecompany,
      netpremium,
      odpremium,
      tppremium,
      policyno,
      policytype,
      totalcomm,
      vehiclemodel,
      vehicleregno,
      DSO,
      DSOName,
      broker,
      brokername,
      policycategory
    );
    if (
      brokerorself === "" ||
      insurancecompany === "" ||
      policyno === "" ||
      policytype === "" ||
      vehiclemodel === "" ||
      vehicleregno === "" ||
      paymentDate === "" ||
      modelyear === "" ||
      customername === undefined
    ) {
      toaster.push(<Message type="error">{`All Fields are required.`}</Message>);
      return;
    }
    try {
      const datatosend = {
        ...policyData,
        customername,
        paymentDate: moment(startDate).format("YYYY-MM-DD"),
        startDate: moment(startDate).format("YYYY-MM-DD"),
        policyDate: moment(policyDate).format("YYYY-MM-DD"),
        policyenddate: moment(selectedDate).format("YYYY-MM-DD"),
      };
      console.log(datatosend);
      const response = await axiosPrivate.post("/AddPolicy.php", datatosend);
      console.log(response);
      setpolicyID(result.PolicyID);
      if (result.status === 1) {
        toaster.push(<Message type="success">{`Policy added successfully`}</Message>);
        setOpenAddCustomer(false);
        setAddCustomerData({});
        setType("");
        getCustomers();
      }

      if (result.status === 0) {
        toaster.push(
          <Message type="error" header="Error">
            {result.Error}
          </Message>
        );
      }
    } catch (err) {
      console.error(err);
      //navigate("/login", { state: { from: location }, replace: true });
    }
  };

  const getCustomers = () => {
    axiosPrivate
      .post("/LoadCustomersList.php")
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: `${item.Fullname} (${item.SrNo})`,
              value: item.UniqueID,
            }));
            // console.log(data);
            setCustomersList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setCustomersList([]);
        }
      })
      .catch((e) => {
        setCustomersList([]);
      });
  };

  const getInsuranceCo = () => {
    axiosPrivate
      .post("/LoadInsuranceCompanyList.php")
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: item.Name,
              value: item.Name,
            }));
            // console.log(data);
            setInsuranceCoList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setInsuranceCoList([]);
        }
      })
      .catch((e) => {
        setInsuranceCoList([]);
      });
  };

  const getPolicyType = () => {
    axiosPrivate
      .post("/LoadPolicyTypeList.php")
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: item.Name,
              value: item.Name,
            }));
            // console.log(data);
            setPolicyTypeList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setPolicyTypeList([]);
        }
      })
      .catch((e) => {
        setPolicyTypeList([]);
      });
  };

  const getVillageList = () => {
    axiosPrivate
      .post("/LoadVillageList.php")
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: item.Name,
              value: item.Name,
            }));
            // console.log(data);
            setVillageList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setVillageList([]);
        }
      })
      .catch((e) => {
        setVillageList([]);
      });
  };

  const getUsersByType = () => {
    axiosPrivate
      .post("/LoadAgentList.php", { Type: "DahiyaMitra" })
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: item.Name,
              value: item.UniqueID,
            }));
            const a = [{ label: "Self", value: "Self" }].concat(data);
            // console.log(data);
            setUsersList(a);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setUsersList([]);
        }
      })
      .catch((e) => {
        setUsersList([]);
      });
  };
  const getUsersBroker = () => {
    axiosPrivate
      .post("/LoadAgentList.php", { Type: "Broker" })
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: item.Name,
              value: item.UniqueID,
            }));
            // console.log(data);
            setBrokerList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setBrokerList([]);
        }
      })
      .catch((e) => {
        setBrokerList([]);
      });
  };

  const getVehicleType = () => {
    axiosPrivate
      .post("/LoadVehicleTypeList.php")
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: item.Name,
              value: item.Name,
            }));
            // console.log(data);
            setVehicleTypeList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setVehicleTypeList([]);
        }
      })
      .catch((e) => {
        setVehicleTypeList([]);
      });
  };

  const getPaidVia = () => {
    axiosPrivate
      .post("/LoadPaidViaList.php")
      .then((response) => {
        const result = response.data;
        if (response && response["status"] === 200) {
          if (result.status === 1) {
            const data = result.Data.map((item) => ({
              label: item.Name,
              value: item.Name,
            }));
            // console.log(data);
            setPaidViaList(data);
          }
        }
        if (response && (response["status"] === 401 || response["status"] === 403)) {
          //console.log(result.Data);
          setPaidViaList([]);
        }
      })
      .catch((e) => {
        setPaidViaList([]);
      });
  };
  const refershallDropdown = () => {
    getCustomers();
    getUsersBroker();
    getInsuranceCo();
    getPolicyType();
    getVehicleType();
    getUsersByType();
    getPaidVia();
    getVillageList();
    getCasteList();
    getPolicyCategoryList();
  };
  React.useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      refershallDropdown();
    }

    return () => {
      isMounted = false;
    };
  }, []);
  function checkIfMobileNoExists() {
    if (!addCustomerData?.mobile2 || addCustomerData?.mobile2 === "") {
    } else {
      try {
        axiosPrivate
          .post("/CheckIfMobileNoExistForCustomer.php", { Mobile: addCustomerData?.mobile2 })
          .then((response) => {
            const result = response.data;
            if (result.status === 1) {
              if (result.App.length > 0) {
                /* toaster.push(
                  <Notification type="error" header="Error">
                    {`This Mobile no already resgistered with ${result.App.length} customer(s) - ${result.Data[0].SrNo}.`}
                  </Notification>,
                  { placement: "topEnd" },
                  { duration: 1000 }
                ); */
                confirmAlert({
                  customUI: ({ onClose }) => {
                    return (
                      <div className="custom-ui">
                        <h1>{`Are you sure?`}</h1>
                        <p>{`This Mobile no already resgistered with ${result.App.length} customer(s) - ${result.Data[0].SrNo}. Continue?`}</p>
                        <button onClick={onClose}>Continue</button>
                        <button
                          onClick={() => {
                            setAddCustomerData({});
                            onClose();
                          }}
                        >
                          No
                        </button>
                      </div>
                    );
                  },
                });
              }
            }
            if (result.status === 0) {
            }
          })
          .catch((err) => {
            console.error(err);
          });

        //navigate("/login", { state: { from: location }, replace: true });
      } catch (err) {
        console.error(err);
        //navigate("/login", { state: { from: location }, replace: true });
      }
    }
  }
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <div
                style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white">
                  {policyID ? `Add New Policy - DIFS/KATAR/${policyID}` : "Add New Policy"}
                </MDTypography>
                <div style={{ flex: 1 }}></div>
                <div>
                  <Button
                    disabled={policyID}
                    style={{ color: "white", backgroundColor: "#2979ff" }}
                    onClick={AddPolicyData}
                    startIcon={<SaveIcon />}
                  >
                    Submit
                  </Button>
                  &nbsp; &nbsp;
                  <Button
                    style={{ color: "white", backgroundColor: "#2979ff" }}
                    disableElevation
                    onClick={() => {
                      setPolicyData({});
                      setpolicyID(null);
                    }}
                    startIcon={<RestartAltIcon />}
                  >
                    Clear
                  </Button>
                </div>
              </div>
            </MDBox>
            <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }} pt={3}>
              <Grid item xs={12} md={6} lg={4} pt={2}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Broker :</InputLabel>
                  </Grid>
                  <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                    <SelectPicker
                      disabled={policyID}
                      block={true}
                      appearance="default"
                      name="broker"
                      value={policyData.broker}
                      onSelect={(e, Item) => {
                        setPolicyData((a) => {
                          return { ...a, broker: e, brokername: Item.label };
                        });
                      }}
                      data={brokerList}
                      cleanable={false}
                    />
                    <IconButton
                      disabled={policyID}
                      color="primary"
                      aria-label="add to shopping cart"
                      onClick={handleOpenAddBroker}
                    >
                      <PlusIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4} pt={2}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Dahiya Mitra / Self :</InputLabel>
                  </Grid>
                  <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                    <SelectPicker
                      disabled={policyID}
                      cleanable={false}
                      block={true}
                      appearance="default"
                      value={policyData.DSO}
                      onSelect={(e, Item) => {
                        setPolicyData((a) => {
                          return { ...a, DSO: e, DSOName: Item.label };
                        });
                      }}
                      data={usersList}
                    />
                    <IconButton
                      disabled={policyID}
                      color="primary"
                      aria-label="add to shopping cart"
                      onClick={handleOpenAddDSO}
                    >
                      <PlusIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              {policyData.DSOName === "Self" && (
                <Grid item xs={12} md={6} lg={4} pt={2}>
                  <Grid
                    xs={12}
                    container
                    style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                  >
                    <Grid xs={5} style={{ justifyContent: "center" }}>
                      <InputLabel style={{ fontWeight: "bold" }}>Customer Name :</InputLabel>
                    </Grid>
                    <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                      <SelectPicker
                        disabled={policyID}
                        appearance="default"
                        value={customername}
                        onChange={(e, item) => setcustomername(e)}
                        data={customersList}
                        cleanable={false}
                      />
                      {(auth.permissions.includes(CREATE_CUSTOMER) ||
                        auth.user.Type === "SuperAdmin") && (
                        <IconButton
                          disabled={policyID}
                          color="primary"
                          aria-label="add "
                          onClick={handleOpenAddCustomer}
                        >
                          <PlusIcon />
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Policy No :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={policyID}
                      value={policyData?.policyno || ""}
                      name="policyno"
                      placeholder="Type policy no"
                      id="policyno"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Policy Date :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        disabled={policyID}
                        cleanable={false}
                        format="DD-MM-YYYY"
                        value={policyDate}
                        onChange={setPolicyDate}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Start Date :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        disabled={policyID}
                        cleanable={false}
                        format="DD-MM-YYYY"
                        value={startDate}
                        onChange={setStartDate}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Policy End Date :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        disabled={policyID}
                        format="DD-MM-YYYY"
                        value={selectedDate}
                        onChange={setSelectedDate}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4} pt={2}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Insured Name :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={policyID}
                      value={policyData?.insuredname || ""}
                      name="insuredname"
                      placeholder="Type Insured name"
                      id="insuredname"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>{" "}
              {/* <Grid item xs={12} md={6} lg={4} pt={2}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel>Amount :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                     <TextField
                      fullWidth
                      startAdornment={<InputAdornment position="start">Rs. </InputAdornment>}
                    /> 
                    <FormControl>
                      <InputLabel htmlFor="outlined-adornment-amount">Amount</InputLabel>
                      <OutlinedInput
                        disabled={policyID}
                        id="outlined-adornment-amount"
                        startAdornment={<InputAdornment position="start">₹</InputAdornment>}
                        value={policyData?.amount || ""}
                        name="amount"
                        placeholder="Enter amount"
                        autoComplete="off"
                        onChange={handleAddpolicydata}
                        fullWidth
                        label="Amount"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid> */}
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Insurance Company :</InputLabel>
                  </Grid>
                  <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                    <SelectPicker
                      disabled={policyID}
                      block={true}
                      appearance="default"
                      value={policyData.insurancecompany}
                      onChange={(e, item) => {
                        setPolicyData((c) => {
                          return { ...c, insurancecompany: e };
                        });
                      }}
                      data={insuranceCoList}
                      cleanable={false}
                      fullWidth
                    />
                    <IconButton
                      disabled={policyID}
                      color="primary"
                      aria-label="add to shopping cart"
                      onClick={handleOpenAddInsuranceCo}
                    >
                      <PlusIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Policy Type :</InputLabel>
                  </Grid>
                  <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                    <SelectPicker
                      disabled={policyID}
                      block={true}
                      appearance="default"
                      value={policyData.policytype}
                      onChange={(e, item) => {
                        setPolicyData((c) => ({ ...c, policytype: e }));
                      }}
                      data={policytypeList}
                      cleanable={false}
                    />
                    <IconButton
                      disabled={policyID}
                      color="primary"
                      aria-label="add to shopping cart"
                      onClick={handleOpenAddPolicyType}
                    >
                      <PlusIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Vehicle Make/Model :</InputLabel>
                  </Grid>
                  <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                    <SelectPicker
                      disabled={policyID}
                      block={true}
                      appearance="default"
                      value={policyData.vehiclemodel}
                      onChange={(e, item) => {
                        setPolicyData((prevState) => {
                          return { ...prevState, vehiclemodel: e };
                        });
                      }}
                      data={vehicletypeList}
                      cleanable={false}
                    />
                    <IconButton
                      disabled={policyID}
                      color="primary"
                      aria-label="add to shopping cart"
                      onClick={handleOpenAddVehicleType}
                    >
                      <PlusIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Model Year :</InputLabel>
                  </Grid>
                  <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                    <MaskedInput
                      disabled={policyID}
                      value={policyData?.modelyear}
                      mask={[/\d/, /\d/, /\d/, /\d/]}
                      guide={true}
                      keepCharPositions={true}
                      placeholderChar="_"
                      placeholder="Type Model Year"
                      fullWidth
                      onChange={(e) => {
                        setPolicyData((dt) => {
                          return { ...dt, modelyear: e };
                        });
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Vehicle Reg.No. :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    {/* <MaskedInput
                      disabled={policyID}
                      value={policyData?.vehicleregno}
                      mask={[
                        /[A-Z]/,
                        /[A-Z]/,
                        "-",
                        /\d/,
                        /\d/,
                        "-",
                        /[A-Z]/,
                        /[A-Z]/,
                        "-",
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/,
                      ]}
                      guide={true}
                      keepCharPositions={true}
                      placeholderChar="_"
                      placeholder="Type vehicle registration no"
                      fullWidth
                      onChange={(e) => {
                        setPolicyData((dt) => {
                          return { ...dt, vehicleregno: e };
                        });
                      }}
                    /> */}
                    <TextField
                      disabled={policyID}
                      value={policyData?.vehicleregno}
                      name="vehicleregno"
                      style={{ textTransform: "uppercase" }}
                      placeholder="Type vehicle registration no"
                      id="vehicleregno"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>OD Premium (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={policyID}
                      value={policyData?.odpremium || ""}
                      name="odpremium"
                      placeholder="Type OD premium Amnt"
                      id="odpremium"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>TP Premium (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={policyID}
                      value={policyData?.tppremium || ""}
                      name="tppremium"
                      placeholder="Type TP Premium amnt"
                      id="tppremium"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Net Premium (₹):</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={policyID}
                      value={policyData?.netpremium || ""}
                      name="netpremium"
                      placeholder="Type Net premium"
                      id="newpremium"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Gross Premium (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={policyID}
                      value={policyData?.grosspremium || ""}
                      name="grosspremium"
                      placeholder="Enter gross premium amnt"
                      id="grosspremium"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Comm Net (%) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={
                        policyID ||
                        !(
                          auth.user.Type === "SuperAdmin" ||
                          auth.user.Type === "Admin" ||
                          auth.permissions.includes(AC_PAYOUT)
                        )
                      }
                      value={policyData?.commpernet || ""}
                      name="commpernet"
                      placeholder="Enter Commission % net"
                      id="commpernet"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Comm OD (%) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={
                        policyID ||
                        !(
                          auth.user.Type === "SuperAdmin" ||
                          auth.user.Type === "Admin" ||
                          auth.permissions.includes(AC_PAYOUT)
                        )
                      }
                      value={policyData?.commperod || ""}
                      name="commperod"
                      placeholder="Enter Commission % OD"
                      id="commperod"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Comm TP (%) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={
                        policyID ||
                        !(
                          auth.user.Type === "SuperAdmin" ||
                          auth.user.Type === "Admin" ||
                          auth.permissions.includes(AC_PAYOUT)
                        )
                      }
                      value={policyData?.commpertp || ""}
                      name="commpertp"
                      placeholder="Enter Commission % TP"
                      id="commpertp"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Comm. Net Amount (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={
                        !(
                          auth.user.Type === "SuperAdmin" ||
                          auth.user.Type === "Admin" ||
                          auth.permissions.includes(AC_PAYOUT)
                        )
                      }
                      value={policyData?.commnetamount || ""}
                      name="commnetamount"
                      placeholder="Enter commission net amount"
                      id="commnetamount"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Comm. OD (₹):</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={
                        !(
                          auth.user.Type === "SuperAdmin" ||
                          auth.user.Type === "Admin" ||
                          auth.permissions.includes(AC_PAYOUT)
                        )
                      }
                      value={policyData?.commod || ""}
                      name="commod"
                      placeholder="Enter Commission OD"
                      id="commod"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Comm. TP (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={
                        !(
                          auth.user.Type === "SuperAdmin" ||
                          auth.user.Type === "Admin" ||
                          auth.permissions.includes(AC_PAYOUT)
                        )
                      }
                      value={policyData?.commtp || ""}
                      name="commtp"
                      placeholder="Enter Commission TP"
                      id="commtp"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Total Comm (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={
                        !(
                          auth.user.Type === "SuperAdmin" ||
                          auth.user.Type === "Admin" ||
                          auth.permissions.includes(AC_PAYOUT)
                        )
                      }
                      value={policyData?.totalcomm || ""}
                      name="totalcomm"
                      placeholder="Enter total commission amount"
                      id="totalcomm"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>DR (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      /* disabled={policyID} */
                      disabled
                      value={policyData.grosspremium}
                      name="payableamount"
                      id="payableamount"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>CR I (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={policyID}
                      value={policyData?.paymentmade || 0}
                      name="paymentmade"
                      placeholder="Enter payment made"
                      id="paymentmade"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>CR II (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled={policyID}
                      value={policyData?.discount || 0}
                      name="discount"
                      placeholder="Enter payment discount"
                      id="discount"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Balance (₹) :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      disabled
                      value={policyData?.paymentselfbalance || 0}
                      name="paymentselfbalance"
                      placeholder="Enter payment balance"
                      id="paymentselfbalance"
                      autoComplete="off"
                      onChange={handleAddpolicydata}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Paid Via :</InputLabel>
                  </Grid>
                  <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                    <SelectPicker
                      disabled={
                        policyID ||
                        !(
                          auth.user.Type === "SuperAdmin" ||
                          auth.user.Type === "Admin" ||
                          auth.permissions.includes(AC_PAYOUT)
                        )
                      }
                      block={true}
                      appearance="default"
                      value={policyData.paidvia}
                      onChange={(e, item) => {
                        setPolicyData((prevState) => {
                          return { ...prevState, paidvia: e };
                        });
                      }}
                      data={paidviaList}
                      cleanable={false}
                    />
                    <IconButton
                      disabled={policyID}
                      color="primary"
                      aria-label="add to shopping cart"
                      onClick={handleOpenAddPaidVia}
                    >
                      <PlusIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Grid xs={5} style={{ justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Policy Category :</InputLabel>
                  </Grid>
                  <Grid xs={7} style={{ display: "flex", flexDirection: "row" }}>
                    <SelectPicker
                      disabled={policyID}
                      block={true}
                      appearance="default"
                      searchable={false}
                      value={policyData.policycategory}
                      onChange={(e, item) => {
                        setPolicyData((prevState) => {
                          return { ...prevState, policycategory: e };
                        });
                      }}
                      data={policyCategoryList}
                      cleanable={true}
                    />
                    {/* <IconButton
                      disabled={policyID}
                      color="primary"
                      aria-label="add to shopping cart"
                      onClick={handleOpenAddPaidVia}
                    >
                      <PlusIcon />
                    </IconButton> */}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Grid
                  xs={12}
                  container
                  style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
                >
                  <Uploader
                    disabled={!policyID}
                    removable={false}
                    onRemove={(file) => {
                      console.log(file.name);
                    }}
                    listType="picture-text"
                    fileList={fileList}
                    multiple={true}
                    data={{ ID: policyID }}
                    onChange={setfileList}
                    withCredentials={true}
                    headers={{ Authorization: `Bearer ${auth?.accessToken}` }}
                    action="https://Downloads.dahiyainsurance.com/UploadPolicyDocs.php"
                    renderFileInfo={(file, fileElement) => (
                      <span style={{ width: "100%", fontSize: 14 }}>Name: {file.name}</span>
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>

      {/* ===========================Add Customer=============================== */}

      <Dialog
        open={openAddCustomer}
        onClose={handleCloseAddCustomer}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Add Customer
        </DialogTitle>
        <DialogContent>
          <div style={{ width: 400 }}>
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
              pt={3}
              style={{ paddingLeft: 10, paddingRight: 10 }}
            >
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Ref By :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addCustomerData?.refby || ""}
                    name="refby"
                    placeholder="Type refby"
                    id="refby"
                    autoComplete="off"
                    onChange={handleAddCustomerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Full name :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addCustomerData?.fullname || ""}
                    name="fullname"
                    placeholder="Type full name"
                    id="fullname"
                    autoComplete="off"
                    onChange={handleAddCustomerChange}
                    style={{ fontWeight: "bold" }}
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Mobile No :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    onBlur={checkIfMobileNoExists}
                    value={addCustomerData?.mobile2 || ""}
                    name="mobile2"
                    placeholder="Type mobile number"
                    id="mobile2"
                    autoComplete="off"
                    onChange={handleAddCustomerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Caste :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  {/*                   <TextField
                    value={addCustomerData?.caste || ""}
                    name="caste"
                    placeholder="Type caste"
                    id="caste"
                    autoComplete="off"
                    onChange={handleAddCustomerChange}
                    fullWidth
                    multiline={true}
                  /> */}
                  <SelectPicker
                    block={true}
                    appearance="default"
                    value={addCustomerData.caste}
                    onChange={(e, item) => {
                      setAddCustomerData((c) => {
                        return { ...c, caste: e };
                      });
                    }}
                    data={casteList}
                    style={{ flex: 1 }}
                    cleanable={false}
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Village :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  {/*                   <TextField
                    value={addCustomerData?.village || ""}
                    name="village"
                    placeholder="Type village"
                    id="village"
                    autoComplete="off"
                    onChange={handleAddCustomerChange}
                    fullWidth
                    multiline={true}
                  /> */}
                  <SelectPicker
                    block={true}
                    appearance="default"
                    value={addCustomerData.village}
                    onChange={(e, item) => {
                      setAddCustomerData((c) => {
                        return { ...c, village: e };
                      });
                    }}
                    data={villageList}
                    style={{ flex: 1 }}
                    cleanable={false}
                  />
                </Grid>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseAddCustomer}>
            Cancel
          </Button>
          <Button onClick={AddCustomer}>Add New</Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================================== */}

      {/* ========================Add Insurance CO============================== */}

      <Dialog
        open={openAddInsuranceCo}
        onClose={handleCloseAddInsuranceCo}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Add Insurance Company
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ width: 400 }}>
              <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
                pt={3}
                style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                <Grid
                  xs={12}
                  container
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                    marginBottom: 10,
                  }}
                >
                  <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Insurance Company :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      value={addCustomerData?.insuranceco || ""}
                      name="insuranceco"
                      placeholder="Type Insurance Co"
                      id="insuranceco"
                      autoComplete="off"
                      onChange={handleAddCustomerChange}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseAddInsuranceCo}>
            Cancel
          </Button>
          <Button onClick={AddInsuranceCo}>Add New</Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================================== */}

      {/* =============================Policy Type============================== */}

      <Dialog
        open={openAddPolicyType}
        onClose={handleCloseAddPolicyType}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Add Policy Type
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ width: 400 }}>
              <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
                pt={3}
                style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                <Grid
                  xs={12}
                  container
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                    marginBottom: 10,
                  }}
                >
                  <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Policy Type :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      value={addCustomerData?.policytype || ""}
                      name="policytype"
                      placeholder="Enter policy type"
                      id="policytype"
                      autoComplete="off"
                      onChange={handleAddCustomerChange}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseAddPolicyType}>
            Cancel
          </Button>
          <Button onClick={AddPolicyType}>Add New</Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================================== */}

      {/* =============================Vehicle Type============================= */}

      <Dialog
        open={openAddVehicleType}
        onClose={handleCloseAddVehicleType}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Add Vehicle Type
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ width: 400 }}>
              <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
                pt={3}
                style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                <Grid
                  xs={12}
                  container
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                    marginBottom: 10,
                  }}
                >
                  <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Vehicle Type :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      value={addCustomerData?.vehicleType || ""}
                      name="vehicleType"
                      placeholder="Enter Vehicle Type"
                      id="vehicleType"
                      autoComplete="off"
                      onChange={handleAddCustomerChange}
                      fullWidth
                      multiline={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseAddVehicleType}>
            Cancel
          </Button>
          <Button onClick={AddVehicleType}>Add New</Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================================== */}

      {/* ========================Add DSO=========================== */}

      <Dialog
        open={openAddDSO}
        onClose={handleCloseAddDSO}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Add Dahiya Mitra
        </DialogTitle>
        <DialogContent>
          <div style={{ width: 400 }}>
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
              pt={3}
              style={{ paddingLeft: 10, paddingRight: 10 }}
            >
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Full name :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addDSOData?.fullname || ""}
                    name="fullname"
                    placeholder="Type Full name"
                    id="fullname"
                    autoComplete="off"
                    onChange={handleAddDSOChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Firm Name :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addDSOData?.firmname || ""}
                    name="firmname"
                    placeholder="Type Firm name"
                    id="firmname"
                    autoComplete="off"
                    onChange={handleAddDSOChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>H.N. / Mohalla :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addDSOData?.address || ""}
                    name="address"
                    placeholder="Type Address"
                    id="address"
                    autoComplete="off"
                    onChange={handleAddDSOChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Email ID :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addDSOData?.email || ""}
                    name="email"
                    placeholder="Type email address"
                    id="email"
                    autoComplete="off"
                    onChange={handleAddDSOChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Official Email ID :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addDSOData?.officialemail || ""}
                    name="officialemail"
                    placeholder="Type official email address"
                    id="officialemail"
                    autoComplete="off"
                    onChange={handleAddDSOChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Mobile No :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addDSOData?.mobile || ""}
                    name="mobile"
                    placeholder="Type mobile number"
                    id="mobile"
                    autoComplete="off"
                    onChange={handleAddDSOChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Office No :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addDSOData?.officeno || ""}
                    name="officeno"
                    placeholder="Type Office no"
                    id="officeno"
                    autoComplete="off"
                    onChange={handleAddDSOChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
              >
                <Grid xs={5} style={{ justifyContent: "center", display: "flex" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>User Type :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <Select
                    id="demo-simple-select-helper"
                    style={{ flex: 1, height: 40 }}
                    fullWidth
                    disabled
                    defaultValue="DahiyaMitra"
                  >
                    <MenuItem value="">
                      <em>Select User type</em>
                    </MenuItem>
                    <MenuItem selected value="DahiyaMitra">
                      DahiyaMitra
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseAddDSO}>
            Cancel
          </Button>
          <Button onClick={addDSO}>Create</Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================================== */}

      {/* ========================Add Broker=========================== */}

      <Dialog
        open={openAddBroker}
        onClose={handleCloseAddBroker}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Add Broker
        </DialogTitle>
        <DialogContent>
          <div style={{ width: 400 }}>
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
              pt={3}
              style={{ paddingLeft: 10, paddingRight: 10 }}
            >
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Full name :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addBrokerData?.fullname || ""}
                    name="fullname"
                    placeholder="Type full name"
                    id="fullname"
                    autoComplete="off"
                    onChange={handleAddBrokerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Firm Name :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addBrokerData?.firmname || ""}
                    name="firmname"
                    placeholder="Type firm name"
                    id="firmname"
                    autoComplete="off"
                    onChange={handleAddBrokerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Email ID :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addBrokerData?.email || ""}
                    name="email"
                    placeholder="Type email address"
                    id="email"
                    autoComplete="off"
                    onChange={handleAddBrokerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Official Email :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addBrokerData?.officialemail || ""}
                    name="officialemail"
                    placeholder="Type Official email"
                    id="officialemail"
                    autoComplete="off"
                    onChange={handleAddBrokerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Mobile No :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addBrokerData?.mobile || ""}
                    name="mobile"
                    placeholder="Type mobile number"
                    id="mobile"
                    autoComplete="off"
                    onChange={handleAddBrokerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Office No :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addBrokerData?.officeno || ""}
                    name="officeno"
                    placeholder="Type Office number"
                    id="officeno"
                    autoComplete="off"
                    onChange={handleAddBrokerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{
                  alignItems: "center",
                  paddingLeft: 10,
                  paddingRight: 10,
                  marginBottom: 10,
                }}
              >
                <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>Address :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <TextField
                    value={addBrokerData?.address || ""}
                    name="address"
                    placeholder="Type Address"
                    id="address"
                    autoComplete="off"
                    onChange={handleAddBrokerChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                xs={12}
                container
                style={{ alignItems: "center", paddingLeft: 10, paddingRight: 10 }}
              >
                <Grid xs={5} style={{ justifyContent: "center", display: "flex" }}>
                  <InputLabel style={{ fontWeight: "bold" }}>User Type :</InputLabel>
                </Grid>
                <Grid xs={7}>
                  <Select
                    value="Broker"
                    name="brokertype"
                    style={{ flex: 1, height: 40 }}
                    fullWidth
                    defaultValue="Broker"
                    disabled
                  >
                    <MenuItem value="">
                      <em>Select User type</em>
                    </MenuItem>
                    <MenuItem selected value="Broker">
                      Broker
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseAddBroker}>
            Cancel
          </Button>
          <Button onClick={AddBroker}>Create</Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================================== */}

      {/* ========================Add Insurance CO============================== */}

      <Dialog
        open={openAddPaidVia}
        onClose={handleCloseAddPaidVia}
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Add Payment Method
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ width: 400 }}>
              <Grid
                container
                rowSpacing={3}
                columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 3 }}
                pt={3}
                style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                <Grid
                  xs={12}
                  container
                  style={{
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                    marginBottom: 10,
                  }}
                >
                  <Grid xs={5} style={{ display: "flex", justifyContent: "center" }}>
                    <InputLabel style={{ fontWeight: "bold" }}>Method :</InputLabel>
                  </Grid>
                  <Grid xs={7}>
                    <TextField
                      value={addCustomerData?.paidvia || ""}
                      name="paidvia"
                      placeholder="Type payment method"
                      id="paidvia"
                      autoComplete="off"
                      onChange={handleAddCustomerChange}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseAddPaidVia}>
            Cancel
          </Button>
          <Button onClick={AddPaidVia}>Add New</Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================================== */}
    </DashboardLayout>
  );
}

export default NewEntry;
